import React from 'react'
import { useRouter } from 'next/router'
// Components
import Header from '@/components/newHeader/Header'
import LandingHero from '@/components/vets/LandingHero'
import RelatedBlog from '@/components/vets/RelatedBlog'
import Footer from '@/components/newFooter/newFooter'
import SearchResult from '@/components/vets/SearchResult/SearchResult'
import { getAllPosts } from '@/components/blog/lib/cosmic'
import BasicHeadSeo from '@/components/basicHeadSeo'
// Utils
import { categorizePosts } from '@/components/blog/lib/utils'
import { citiesByState } from '@/utils/countries_and_states'
import { slugReverter, capitalizeFirstLetterOfTitle } from '@utils'
import { PostDataType } from '@types'

import { ROBOTS_META } from 'const'

import styles from '../index.module.scss'

interface StatesProps {
  posts: PostDataType[]
}

export default function States({ posts }: StatesProps) {
  const categorizedPosts = (categorizePosts(posts) || {}) as Record<string, PostDataType[]>
  const router = useRouter()

  const statePath = typeof router.query.state === 'string' ? router.query.state.toUpperCase() : ''
  const cityQuery = typeof router.query.city === 'string' ? router.query.city : ''
  const cityPath = capitalizeFirstLetterOfTitle(cityQuery)

  return (
    <>
      <BasicHeadSeo
        title={`Find a Vet in ${slugReverter(cityPath)}, ${statePath} | MawooPets.com`}
        description={`Looking for a reputable veterinarian in [city, state]? Our Mawoo Pets veterinary directory is here to help you find some of the best vets and animal clinics in ${slugReverter(cityPath)}, ${statePath}.`}
        url={`${process.env.NEXT_PUBLIC_ROOT_URL}/find-a-vet/${statePath}/${cityPath}`}
        image={`${process.env.NEXT_PUBLIC_ROOT_URL}/mawoo_social_1600x906.png`}
        content={ROBOTS_META}
      />

      <div className={styles.main}>
        <Header />
        <LandingHero
          state={statePath}
          city={slugReverter(cityPath)}
          citiesByState={citiesByState}
        />
        <SearchResult
          state={statePath}
          city={slugReverter(cityPath)}
          citiesByState={citiesByState}
        />
        {/* <Questions /> */}
        <RelatedBlog categorizedPosts={categorizedPosts} />
        <Footer />
      </div>
    </>
  )
}

export async function getServerSideProps() {
  try {
    const posts = await getAllPosts()

    return {
      props: {
        posts,
      },
    }
  } catch (err) {
    console.error(err)
    throw err
  }
}
